import React, { useEffect } from 'react'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useDataChange } from 'Simple/Data.js'
import { isCoreEmbedMessage } from 'Data/isCoreEmbedMessage.js'

import View from './view.js'

export default function Logic(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let refreshTreatmentPlanNotes = useDataChange({
    context: 'refresh',
    path: 'treatment_plan_notes',
    viewPath: props.viewPath,
  })
  let changeGenerateLetters = useDataChange({
    context: 'generate_letters',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    window.addEventListener('message', listener, false)

    return () => {
      window.removeEventListener('message', listener)
    }

    async function listener(event) {
      if (!isCoreEmbedMessage(event)) {
        return
      }

      if (event.data.type === 'close_section') {
        refreshTreatmentPlanNotes(Date.now())
        setFlowTo(normalizePath(props.viewPath, '../No'))
      }

      if (event.data.type === 'show_letter_generation_modal') {
        refreshTreatmentPlanNotes(Date.now())
        changeGenerateLetters(event.data.params)
        setFlowTo(normalizePath(props.viewPath, '../DiagnosisLetters'))
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <View {...props} />
}
